import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-CC9YFHWNQ1';

ReactGA.initialize(GA_MEASUREMENT_ID);

export const trackPage = (page) => {
  ReactGA.send({ hitType: 'pageview', page: page });
};

export const analyticEvent = (category, action, label, details = {}) => {
  if (process.env.NODE_ENV === 'production') {
    let eventParameters = {
      ...details,
      category,
      action,
      label,
    };
    ReactGA.event(action, eventParameters);
  }
};